import { Menu, MenuItem } from '@headlessui/react'
import React, { useState } from 'react'
import { FaCaretDown, FaWhatsapp } from 'react-icons/fa'
import { MyLink } from '../MyLink'
import { whatsAppDisplay, whatsAppUrl } from 'utils/business-info'

export const TrainerNavBarSmall = ({waInd}) => {
    
    const [ isExpand, setIsExpand ] = useState(false)
    const [ isTrainerExpand, setIsTrainerExpand ] = useState(false)

  return (
    <>
        <li>
            <div className='flex justify-center'>
                <button type="button" onClick={() => setIsExpand(!isExpand)} aria-label='Trainers by fitness goal and type'
                    className=" flex justify-center px-2 py-2  text-orange-600">
                    <strong className='flex'>Services<FaCaretDown className="h-5 w-5"/></strong>
                </button>
            </div>
            {isExpand &&
                <ul className='relative space-y-2'>
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/1-on-1-personal-training" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            1-on-1 Personal Training
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/buddy-training" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            Buddy Training
                        </MyLink>
                    </MenuItem>                   
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/private-home-trainer" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            Home Personal Trainer
                        </MyLink>
                    </MenuItem> 
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/corporate-training" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            Corporate Training
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/blogs/health-fitness/ippt-personal-trainer-singapore" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            IPPT Preparation
                        </MyLink>
                    </MenuItem> 
                </ul>    
            }
        </li>
        <li>
            <div className='flex justify-center'>
                <button type="button" onClick={() => setIsTrainerExpand(!isTrainerExpand)} aria-label='Trainers by fitness goal and type'
                    className=" flex justify-center px-2 py-2  text-orange-600">
                    <strong className='flex'>Trainers<FaCaretDown className="h-5 w-5"/></strong>
                </button>
            </div>
            {isTrainerExpand &&
                <ul className='relative space-y-2'>
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/personal-trainer-singapore-female" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            Female Personal Trainer
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/freelance-personal-trainer-singapore" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            Freelance Personal Trainer
                        </MyLink>
                    </MenuItem>   
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/weight-loss-trainer" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                           Trainer for Weight Loss
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/body-building-trainer" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            Trainer for Muscle Gain
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/prenatal-postpartum-training" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            Prenatal &amp; Postpartum Trainer
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/personal-trainer-for-elderly" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            Trainer for Elderly
                        </MyLink>
                    </MenuItem>
                    <MenuItem>
                        <MyLink href="/sg/personal-trainer/personal-trainer-for-functional-fitness" prefetch={false} className='text-orange-500 text-sm p-2 block'>
                            Functional Fitness Trainer
                        </MyLink>
                    </MenuItem>
                </ul>    
            }
        </li>
        <MenuItem> 
            <MyLink href="/sg/personal-trainer/packages" 
                prefetch={false} className="flex justify-center px-2 py-2 text-orange-600" aria-current="page" aria-label="StringsSG Personal Training Packages">
                Packages                   
            </MyLink>
        </MenuItem>
        <MenuItem>
            <MyLink href="/sg/personal-trainer/personal-trainer-rates-singapore"
                prefetch={false} className="flex justify-center px-2 py-2 text-orange-600" aria-current="page" aria-label="Personal Trainer Rates">
                Rates
            </MyLink>
        </MenuItem>
        <MenuItem>
            <MyLink href="/sg/personal-trainer/careers"
                prefetch={false} className="flex justify-center px-2 py-2 text-orange-600" aria-label="Personal Trainer Careers">
                Careers
            </MyLink>
        </MenuItem>
        <MenuItem>
            <MyLink href={`/sg/blogs/health-fitness`}
                    prefetch={false} className="flex justify-center px-2 py-2 text-orange-600" aria-label="Health & Fitness Blogs">
                Blogs                        
            </MyLink>            
        </MenuItem> 
        <MenuItem as="li">
            <div className='flex justify-center items-center text-white pb-3'>
                <a
                    href={`${whatsAppUrl}?text=${encodeURIComponent("Hi, I'd like to book a personal trainer.")}`}
                    target='_blank'
                    rel='noreferrer'
                    aria-label='WhatsApp StringsSG to book a personal trainer'
                    className='flex items-center gap-2 bg-linear-to-tr from-green-700 to-green-500 text-white text-sm font-bold px-5 py-2.5 rounded-full shadow-lg'
                >
                    <FaWhatsapp className='text-base' />
                    WhatsApp {whatsAppDisplay}
                </a>
            </div> 
        </MenuItem>  
        {/* <MenuItem>
            <MyLink href={`/sg/personal-trainer/join-us-subscription`}
                    prefetch={false} className="flex justify-center px-2 py-2 text-orange-600" aria-label="Personal Trainer Subscription">
                PT Subscription                      
            </MyLink>            
        </MenuItem>   */}
    </>
  )
}
